import RequestsProcessor from "@src/Tools/AxiosRequestsProcessor";
import {action, observable} from "mobx";
import {
    AppStoreApplicationsResponse,
    AppStoreChangeAvailabilityResponse,
    AppStoreInternalApplicationResponse,
    IInternalApplicationForm, IRefreshInternalApplicationTokenResponse,
    IRemoveInternalApplicationResponse,
    IScopeResponse
} from "../../Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {IApiResponse} from "../../Interfaces/Entity/ApiResponse";
import {Toast} from "../../Shared/Tools/Toast";
import {IAppStoreApplicationsRolesResponse, IApplicationsStore, IUserRole} from "./types";

const requestsProcessor: RequestsProcessor = new RequestsProcessor();

class ApplicationsStore implements IApplicationsStore {
    private toast = new Toast();
    @observable roles: IUserRole[] = [];

    @action.bound
    async getScopes() {
        try {
            const response: IApiResponse<IScopeResponse> = await requestsProcessor.get<IApiResponse<IScopeResponse>>("integrations/appstore/applications/scopes", "GetScopes");
            
            if (response.data.hasError == false) {
                return response.data.scopes;
            } else {
                this.toast.showError(response.data.error);
                return null;
            }
        } catch (error) {
            console.error(error);
        }
    }

    @action.bound
    async refreshInternalApplicationToken(id: string) {
        try {
            const response: IApiResponse<IRefreshInternalApplicationTokenResponse> = await requestsProcessor.get<IApiResponse<IRefreshInternalApplicationTokenResponse>>(`integrations/appstore/applications/internal/${id}/token/refresh`, "RefreshInternalApplicationToken");
            const {token, expiresAt} = response.data;
            return {token, expiresAt: expiresAt}
        } catch (error) {
            console.error(error);
        }

    }

    @action.bound
    async removeInternalApplication(id: string) {
        try {
            const response: IApiResponse<IRemoveInternalApplicationResponse> = await requestsProcessor.delete<IApiResponse<IRemoveInternalApplicationResponse>>(`integrations/appstore/applications/internal/${id}`, "RemoveInternalApplication");
            return response.data.result;
        } catch (error) {
            console.error(error);
        }
    }

    @action.bound
    async createInternalApplication(app: IInternalApplicationForm) {
        try {
            const response: IApiResponse<AppStoreInternalApplicationResponse> = await requestsProcessor.post<IApiResponse<AppStoreInternalApplicationResponse>>("integrations/appstore/applications/internal", "CreateInternalApplication", app);
            
            if (response.data.hasError == false) {
                return response.data.application;
            } else {
                this.toast.showError(response.data.error);
                return null;
            }
        } catch (error) {
            console.error(error);
        }
    }

    @action.bound
    async updateInternalApplication(app: IInternalApplicationForm, id: string){
        try {
            const response: IApiResponse<AppStoreInternalApplicationResponse> = await requestsProcessor.post<IApiResponse<AppStoreInternalApplicationResponse>>(`integrations/appstore/applications/internal/${id}`, "UpdateInternalApplication", app);

            if (response.data.hasError == false) {
                return response.data.application;
            } else {
                this.toast.showError(response.data.error);
                return null;
            }
        } catch (error){
            console.error(error);
        }
    }
    
    @action.bound
    async getApplications() {
        try {
            const response: IApiResponse<AppStoreApplicationsResponse> = await requestsProcessor.get<IApiResponse<AppStoreApplicationsResponse>>("integrations/appstore/applications", "GetApplications");
            if (response.data.hasError == false) {
                const {applications, internalApplications} = response.data;
                return {applications, internalApplications};
            } else {
                this.toast.showError(response.data.error);
                return null;
            }
        } catch (error) {
            console.error(error);
        }
    }

    @action.bound
    async changeApplicationStatus(id: string, isAvailable: boolean) {
        try {
            const response: IApiResponse<AppStoreChangeAvailabilityResponse> = await requestsProcessor.patch<IApiResponse<AppStoreChangeAvailabilityResponse>>(`integrations/appstore/applications/${id}/availability`, "ChangeApplicationAvailability",
            {
                isAvailable: isAvailable
            });

            if (response.data.hasError == false) {
                return response.data.result;
            } else {
                this.toast.showError(response.data.error);
                return false;
            }
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    @action.bound
    async getApplicationsUserRoles() {
        try {
            const response: IApiResponse<IAppStoreApplicationsRolesResponse> = await requestsProcessor.get<IApiResponse<IAppStoreApplicationsRolesResponse>>("integrations/appstore/applications/roles", "GetApplicationsUserRoles");
            if (response.data.hasError == false) {
                this.roles = response.data.roles;
                this.roles.forEach((role) => {
                    role.displayTitle = `${role.applicationName} - ${role.name}`;
                });

                return this.roles;
            } else {
                this.toast.showError(response.data.error);
                return null;
            }
        } catch (error) {
            console.error(error);
        }
    }
}

export default ApplicationsStore;
